// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'flag-finish';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.656.576v16.848m0-15.768h14.04c.288 0 .576.216.576.576v9.864a.568.568 0 0 1-.576.576H1.656' />
    <path
      fill='currentColor'
      d='M2.88 1.656h1.224c.648 0 1.224.576 1.224 1.224v1.224c0 .648-.576 1.224-1.224 1.224H2.88c-.648 0-1.224-.576-1.224-1.224V2.88c0-.648.576-1.224 1.224-1.224zm7.344 0h1.224c.648 0 1.224.576 1.224 1.224v1.224c0 .648-.576 1.224-1.224 1.224h-1.224C9.576 5.328 9 4.752 9 4.104V2.88c0-.648.576-1.224 1.224-1.224zM6.552 5.328h1.224C8.424 5.328 9 5.904 9 6.552v1.224C9 8.424 8.424 9 7.776 9H6.552c-.648 0-1.224-.576-1.224-1.224V6.552c0-.648.576-1.224 1.224-1.224zm7.272 0h1.224c.648 0 1.224.576 1.224 1.224v1.224c0 .648-.576 1.224-1.224 1.224h-1.224c-.648 0-1.224-.576-1.224-1.224V6.552c0-.648.504-1.224 1.224-1.224zM2.88 9h1.224c.648 0 1.224.576 1.224 1.224v1.224c0 .648-.576 1.224-1.224 1.224H2.88c-.648 0-1.224-.576-1.224-1.224v-1.224C1.656 9.576 2.232 9 2.88 9zm7.344 0h1.224c.648 0 1.224.576 1.224 1.224v1.224c0 .648-.576 1.224-1.224 1.224h-1.224c-.648 0-1.224-.576-1.224-1.224v-1.224C9 9.576 9.576 9 10.224 9z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
